// 個人戦リーグのプレイヤー選択: 名前での絞り込み検索と並び替え（名前順/対局数順）。
// 既存 leagues/select_players.js の選択ロジックには手を加えず、カードの表示/並び順のみを操作する。
// 既定の並び順は名前順。ツールバー（検索/並び替え）は10人以上のときのみ表示されるため、
// 無い場合でも初期表示を名前順に並べ替える。
$(document).on('turbolinks:load', function () {
  const $list = $('.league-players-list');
  const $cards = $list.find('.league-players-cards');
  if ($list.length === 0 || $cards.length === 0) return;

  const $search = $('.js-player-search');
  const $sort = $('.js-player-sort');
  const $empty = $('.js-player-empty');

  // 現在の並び替えモード（select が無い場合は既定の名前順）
  function currentMode() {
    return $sort.length === 0 ? 'name' : $sort.val();
  }

  // 検索: 入力値に部分一致しないカードを隠す。0件なら「該当なし」を表示
  function applyFilter() {
    const keyword = ($search.val() || '').trim().toLowerCase();
    let visibleCount = 0;
    $cards.find('.league-player-card').each(function () {
      const name = String($(this).data('player-name') || '').toLowerCase();
      const matched = keyword === '' || name.indexOf(keyword) !== -1;
      $(this).toggle(matched);
      if (matched) visibleCount += 1;
    });
    $empty.prop('hidden', visibleCount !== 0);
  }

  // 並び替え: カードを detach -> ソート -> 再 append（チェック状態は要素ごと保持される）
  function applySort() {
    const mode = currentMode();
    const $items = $cards.find('.league-player-card');

    const sorted = $items.toArray().sort(function (a, b) {
      const $a = $(a);
      const $b = $(b);
      if (mode === 'match_count') {
        // 対局が多い順（降順）
        return Number($b.data('match-count')) - Number($a.data('match-count'));
      }
      if (mode === 'match_count_asc') {
        // 対局が少ない順（昇順）
        return Number($a.data('match-count')) - Number($b.data('match-count'));
      }
      // name: 五十音/ABC順の近似（ひらがな/カタカナ/英字は正しい順、漢字は Unicode 順）
      const an = String($a.data('player-name') || '');
      const bn = String($b.data('player-name') || '');
      return an.localeCompare(bn, 'ja');
    });

    $cards.append(sorted);
  }

  $search.on('input', applyFilter);
  $sort.on('change', function () {
    applySort();
    // 並び替え後も現在の検索絞り込み状態を維持する
    applyFilter();
  });

  // 初期表示を既定の名前順に並べ替える
  applySort();
});
